module.exports = __webpack_public_path__ + "img/wallet.fad0ebea.svg";